import type { TestAnswerFeedbackSchemaType } from '@vedalib/editor/lib/brand'
import type { CSSProperties } from 'styled-components'
import styled from 'styled-components'

import type { ElementFeedbackCss } from 'services/Branding/types'

import FailIcon from '../assets/failAnswer.svg?react'
import SuccessIcon from '../assets/successAnswer.svg?react'

export const AnswerStatusStyled = styled.div<{
  $styles: ElementFeedbackCss<TestAnswerFeedbackSchemaType>
  $isTrueAnswer?: boolean
  $isVisible?: boolean | null
  $isVisibleIcon?: boolean | null
}>`
  transition: width 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $styles, $isVisible }) => ($isVisible ? $styles.common__var?.width : 0)};
  flex-shrink: 0;
  height: ${({ $styles }) => $styles.common__var?.height};
  margin-right: ${({ $styles, $isVisible }) => ($isVisible ? $styles.common__var?.marginRight : 0)};
  border-radius: 50%;
  color: ${({ $styles, $isTrueAnswer, $isVisibleIcon }) =>
    $isTrueAnswer
      ? ($styles.correct?.color as CSSProperties['color'])
      : $isVisibleIcon && ($styles.incorrect?.color as CSSProperties['color'])};
  background-color: ${({ $styles, $isTrueAnswer, $isVisibleIcon }) =>
    $isTrueAnswer
      ? ($styles.correct?.backgroundColor as CSSProperties['backgroundColor'])
      : $isVisibleIcon && ($styles.incorrect?.backgroundColor as CSSProperties['backgroundColor'])};
`

export const StyledSuccess = styled(SuccessIcon)`
  display: block;
  object-fit: contain;
`

export const StyledFail = styled(FailIcon)`
  display: block;
  object-fit: contain;
`
